const parametrizacao_de_prazo_de_encerramento = [
  {
    path: "/parametrizacao-de-prazo-de-encerramento",
    name: "parametrizacao_de_prazo_de_encerramento",
    meta: {
      allowedPermissions: [
        "prazo_encerramento_save",
        "prazo_encerramento_buscar",
      ],
      breadCrumb: "Processo de Resultado Final - Relatório Final da Escola",
    },
    component: () =>
      import(
        "@/views/ParametrizacaoDePrazoDeEncerramento/ParametrizacaoDePrazoDeEncerramento.vue"
      ),
  },
];

export { parametrizacao_de_prazo_de_encerramento };
